import {
  HealthIndicatorEntry,
  HealthStatus,
  RedriveStatus,
} from "../types/health";

const healthIndicator: Record<HealthStatus, HealthIndicatorEntry> = {
  healthy: {
    type: "success",
    color: "text-status-success",
    message: "This transaction is healthy",
  },
  unhealthy: {
    type: "error",
    color: "text-status-error",
    message: "This transaction has issues",
  },
  pending: {
    type: "pending",
    color: "text-status-inactive",
    message: "This transaction is in progress",
  },
  unknown: {
    type: "in-progress",
    color: "text-status-inactive",
    message: "This transaction is unknown",
  },
  "not-applicable": {
    type: "in-progress",
    color: "text-status-inactive",
    message: "No publishable CBEs",
  },
};

export const redriveHealthIndicator: Record<
  RedriveStatus,
  HealthIndicatorEntry
> = {
  SUCCEEDED: {
    type: "success",
    color: "text-status-success",
    message: "This Redrive was successful",
  },
  ABORTED: {
    type: "error",
    color: "text-status-error",
    message: "This redrive was manually aborted",
  },
  FAILED: {
    type: "error",
    color: "text-status-error",
    message: "This redrive failed",
  },
  IN_PROGRESS: {
    type: "pending",
    color: "text-status-inactive",
    message: "This redrive is still in progress",
  },
};

export default healthIndicator;
